var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WorkspaceEvidenceTable", {
    attrs: {
      title: _vm.title,
      rows: _vm.rows,
      columns: _vm.columns,
      "page-size": _vm.pageSize,
      "empty-note": _vm.emptyNote,
      bordered: _vm.bordered,
      "pagination-label": "CFDE gene set pages",
    },
    scopedSlots: _vm._u([
      {
        key: "add",
        fn: function ({ row }) {
          return [
            _vm.isOnGraph(row)
              ? _c(
                  "button",
                  {
                    staticClass:
                      "wkb-cfde-gene-set-btn wkb-cfde-gene-set-btn--remove",
                    attrs: { type: "button", disabled: _vm.graphBusy },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove-gene-set", row)
                      },
                    },
                  },
                  [_vm._v(" Remove ")]
                )
              : _c(
                  "button",
                  {
                    staticClass:
                      "wkb-cfde-gene-set-btn wkb-cfde-gene-set-btn--add",
                    attrs: { type: "button", disabled: _vm.graphBusy },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("add-gene-set", row)
                      },
                    },
                  },
                  [_vm._v(" Add ")]
                ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }